var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { IdpCompatibilityMode } from "healthex-common/organization.dtos";
import { autorun, computed, observable } from "mobx";
import { SimpleDialogModel } from "../SimpleDialogModel";
export class GlobalAdminOrganizationFormModelBase {
    get showFullDetail() {
        return this.opts.mode !== "new";
    }
    constructor(opts) {
        this.legacyIdpModeConfirmationDialogModel = new SimpleDialogModel();
        this.savedIdpCompatibilityMode = IdpCompatibilityMode.OIDC;
        this.opts = opts;
        this.editing = opts.mode === "new";
        window.setTimeout(() => {
            autorun(() => {
                if (opts.mode === "detail") {
                    void this.loadOrganization(opts.organizationId, false);
                }
            });
        }, 0);
    }
    setSavedIdpCompatibilityMode(mode) {
        this.savedIdpCompatibilityMode = mode;
    }
    get selectedIdpCompatibilityMode() {
        return IdpCompatibilityMode.OIDC;
    }
    get isSelectingLegacyIdpMode() {
        return this.selectedIdpCompatibilityMode === IdpCompatibilityMode.LEGACY;
    }
    async saveWithIdpModeConfirmation() {
        const isDowngrade = this.isSelectingLegacyIdpMode && this.savedIdpCompatibilityMode !== IdpCompatibilityMode.LEGACY;
        if (isDowngrade && !(await this.legacyIdpModeConfirmationDialogModel.showAndWait())) {
            return;
        }
        await this.save();
    }
    cancel() {
        if (this.opts.mode === "new") {
            this.opts.onCancel();
        }
        else {
            this.editing = false;
            void this.loadOrganization(this.opts.organizationId, false);
        }
    }
    async save() {
        if (this.opts.mode === "new") {
            const createInitialUserInput = this.opts.getCreateInitialUserInput();
            if (createInitialUserInput) {
                const organizationId = await this.performCreate(createInitialUserInput);
                if (organizationId) {
                    await this.loadOrganization(organizationId, true);
                    this.opts.onCreate(organizationId);
                }
            }
        }
        else {
            await this.performUpdate();
            this.editing = false;
            await this.loadOrganization(this.opts.organizationId, true);
        }
    }
    async performUpdate() { }
}
__decorate([
    observable
], GlobalAdminOrganizationFormModelBase.prototype, "editing", void 0);
__decorate([
    computed
], GlobalAdminOrganizationFormModelBase.prototype, "showFullDetail", null);
__decorate([
    observable
], GlobalAdminOrganizationFormModelBase.prototype, "savedIdpCompatibilityMode", void 0);
__decorate([
    computed
], GlobalAdminOrganizationFormModelBase.prototype, "isSelectingLegacyIdpMode", null);
